<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete Sales Quote</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Are you sure do you want to delete this sales quote?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="dangerButton" @click="deleteUser">Delete permanently</button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('salesquote', {
      showDeleteModal: state => state.showDeleteModal,
      salesQuote: state => state.salesQuote
    })
  },
  methods: {
    ...mapActions('salesquote', ['openDeleteModal', 'getPaginatedSalesQuotes']),
    deleteUser() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(`api/salesquotes/${this.salesQuote.salesQuoteId}`)
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            appToast.danger(error.response.data)
          }
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })
      this.getPaginatedSalesQuotes({
        page: 1,
        pageSize: 10,
        query: ''
      })
    }
  }
}
</script>
